import { Box, FormControl, FormControlLabel, Grid, Paper, RadioGroup, Stack, ThemeProvider, Typography } from '@mui/material'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { autorun, reaction, toJS } from 'mobx'
import styled from '@emotion/styled'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'
import storeAuth from 'GlobalStores/User/StoreAuth'
import { capitalize } from 'lodash'
import { getBrowserOS } from 'Helpers/Bowser'
import storeUser from 'GlobalStores/User/StoreUser'
import { isSomething } from 'Utils/Utils'
import { useNavigate } from 'react-router-dom'
import storeTaxInvoice from 'GlobalStores/Checkout/StoreTaxInvoice'
import { DefaultButton, DefaultInput } from 'Components/Elements/Forms'
import ModalSearch from 'Components/Elements/Forms/ModalSearch/ModalSearch'
import Errors from 'Components/Elements/Errors/Errors'
import storeFormAddress from 'GlobalStores/Checkout/StoreFormAddress'
import ThailandProvinceSelect from 'Components/Elements/Forms/ThailandProvinceSelect/ThailandProvinceSelect'
import { ReactComponent as LockIcon } from 'Components/Elements/Forms/Assets/Lock.svg'
import RadioButton from 'Components/Elements/Forms/RadioButton/RadioButton'
import { MainTemplate } from 'Components/Template/MainTemplate'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import ThemeSelector from 'Components/Elements/Checkout/ThemeSelector'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry';



const TaxInvoice = observer(props => {
    const translate = useTranslate()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)

    const qs = new URLSearchParams(window.location.search)

    const inputs = [
        'fullNameNative',
        'fullName',
        'company_name',
        'company_name_en',
        'branch_number',
        'zip_code',
        'province',
        'district',
        'sub_district',
        'street',
        'house_number'
    ]

    useEffect(() => {
        storeTaxInvoice.SetInvoiceFormsErrors([])
        autorun(disposer => {
            if (storeCheckout.GetShippingForm().length > 0 && !isSomething(storeCheckout.GetUuid())) {
                if (storeTaxInvoice.invoiceType === 'individual') {
                    initIndividualForm()
                } else {
                    initCorporateForm()
                }

                disposer.dispose()
            }
        })

        const disposerRectionTaxType = reaction(
            () => storeTaxInvoice.invoiceType,
            newValue => {
                storeTaxInvoice.invoiceFormsErrors = []
                if (!isSomething(storeCheckout.GetUuid())) {
                    if (newValue === 'individual') {
                        initIndividualForm(false)
                    } else {
                        initCorporateForm(false)
                    }
                }
            }
        )

        initIndividualForm()
        initCorporateForm()

        return () => {
            disposerRectionTaxType()
        }
    }, [])

    const initIndividualForm = (isClearValue = true) => {
        let forms = []

        if (storeTaxInvoice.invoiceIndividualForms.length === 0) {

            forms = toJS(storeCheckout.GetShippingForm())

            forms.map(item => {
                item.value = ''
                let restore = storeTaxInvoice.invoiceForms.find(item2 => item2.key === item.key)
                if (restore) {
                    item.value = restore.value
                }
                return item
            })

            // forms.push({
            //     key: 'fullNameEn',
            //     args: null,
            //     label: 'fullname_en',
            //     placeholder: '',
            //     type: 'text',
            //     value: ''
            // })

            let rearrange = []

            inputs.map(item => {
                let restore = forms.find(item2 => item2.key === item)

                if (restore) {
                    // if (restore.key === 'fullName') {
                    //     restore.key = 'fullNameTh'
                    // }
                    rearrange.push(restore)
                }
            })

            // rearrange.unshift({
            //     key: 'fullNameTh',
            //     args: null,
            //     label: 'fullname',
            //     placeholder: '',
            //     type: 'text',
            //     value: ''
            // })

            storeTaxInvoice.invoiceIndividualForms = rearrange
        }
    }

    const initCorporateForm = (isClearValue = true) => {
        // localObserver.individualForm = toJS(storeReferralCheckout.invoiceForms)
        let forms = []
        if (storeTaxInvoice.invoiceCorporateForms.length === 0) {
            forms = toJS(storeCheckout.GetShippingForm())
            forms = forms.filter(item => item.key !== 'fullName' && item.key !== 'fullNameNative')

            forms.unshift({
                key: 'branch_number',
                type: 'BranchSelect',
                value: 'main_office',
                args: null,
                label: 'branch_number'
            })

            forms.unshift({
                key: 'company_name_en',
                type: 'text',
                value: '',
                args: null,
                label: 'company_name_en'
            })
            forms.unshift({
                key: 'company_name',
                type: 'text',
                value: '',
                args: null,
                label: 'company_name'
            })

            forms.map(item => {
                item.value = ''
                let restore = storeTaxInvoice.invoiceCorporateForms.find(item2 => item2.key === item.key)
                if (restore) {
                    item.value = restore.value
                }
                if (item.key === 'branch_number') {
                    item.value = 'main_office'
                }

                return item
            })

            let rearrange = []

            inputs.map(item => {
                let restore = forms.find(item2 => item2.key === item)
                if (restore) {
                    rearrange.push(restore)
                }
            })

            storeTaxInvoice.invoiceCorporateForms = rearrange
        }
    }

    const SaveTaxInvoice = async () => {
        storeTaxInvoice.invoiceFormsErrors = []
        let data = toJS(storeTaxInvoice.GetTaxInvoiceValues())
        let payerNo = ''

        delete data.email
        delete data.phone

        if (storeTaxInvoice.invoiceType === 'individual') {
            data.government_id = storeTaxInvoice.invoiceGovernmentId
            payerNo = data.government_id
        } else {
            data.tax_id = storeTaxInvoice.invoiceTaxId
            payerNo = data.tax_id
        }

        const postData = {
            uuid: qs.get('uuid'),
            medium: 'Internet',
            agent: 'uFeelgreat',
            platform: getBrowserOS().name,
            period: storeCheckout.period,
            tax_invoice: 1,
            tax_invoice_type: capitalize(storeTaxInvoice.invoiceType),
            tax_invoice_zip_code: data.zip_code,
            tax_invoice_province: data.province,
            tax_invoice_district: data.district,
            tax_invoice_sub_ditrict: data.sub_district,
            tax_invoice_street: data.street,
            tax_invoice_house_no: data.house_number,
            selectAddressHistory: storeFormAddress.typeFormAddress
        }

        if (storeTaxInvoice.invoiceType === 'corporate') {
            postData.tax_invoice_branch_no = data.branch_number
            postData.tax_invoice_company_name = data.company_name
            postData.tax_invoice_company_name_en = data.company_name_en
            postData.tax_invoice_payer_no = payerNo
        } else {
            postData.tax_invoice_gov_id = payerNo
            postData.tax_invoice_full_name = data.fullNameNative
            postData.tax_invoice_full_name_en = data.fullName
        }

        if (storeAuth.isAuthorized) {
            postData.ba_status = storeAuth.userStatus
            postData.login_id = storeAuth.GetId()
            postData.login_name = storeUser.CustomerData().Name()
            postData.login_name_native = storeUser.CustomerData().NativeName()
            postData.token = storeAuth.GetToken()
        }

        try {
            setIsLoading(true)
            const response = await FeelGreatAPI.ValidateTaxInvoice(postData)
            if (response.data.success === false) {
                let errors = response.data.Message_v2
                errors.map(item => {
                    storeTaxInvoice.invoiceFormsErrors.push(translate(item))
                })
            } else {
                storeTaxInvoice.invoiceFormsErrors = []
                storeTaxInvoice.invoiceInformation = postData
                storeTaxInvoice.requestTaxInvoice = true
                navigate(-1)
            }
            setIsLoading(false)
        } catch (e) {
            setIsLoading(false)
        }
    }

    const taxIdFormatter = id => {
        const number = id.trim().replace(/[^0-9]/g, "");
        if (number.length < 1) return number
        if (number.length < 6) return number.replace(/(\d{1})(\d{1})/, "$1-$2")
        if (number.length < 11) return number.replace(/(\d{1})(\d{4})(\d{1})/, "$1-$2-$3")
        if (number.length < 13) return number.replace(/(\d{1})(\d{4})(\d{5})(\d{1})/, "$1-$2-$3-$4")
        return number.replace(/(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/, "$1-$2-$3-$4-$5")
    }

    return (
        <ThemeProvider theme={MainTemplate}>
            <TaxInvoiceWrapper>
                <Stack className="sub-wrapper">
                    <Stack>
                        <Stack
                            sx={{
                                padding: "24px"
                            }}>
                            <Typography
                                component="h2"
                                sx={{ fontSize: "24px", fontWeight: 700 }}
                            >
                                {translate('request_for_full_tax_invoice')}
                            </Typography>
                        </Stack>
                        <Stack
                            padding={{
                                xs: '0px 25px',
                                md: '0px 30px'
                            }}>
                            <FormControl>
                                <RadioGroup>
                                    <RadioGroupStackStyled>
                                        <FormControlLabel
                                            value="individual"
                                            control={<RadioButton />}
                                            label={
                                                <Typography
                                                    component="h4"
                                                    style={{
                                                        color: storeTaxInvoice.invoiceType === 'individual' ? '#003B6F' : '#8A9BB0',
                                                        fontSize: "16px",
                                                        fontWeight: 700
                                                    }}>
                                                    {translate('individual')}
                                                </Typography>
                                            }
                                            checked={storeTaxInvoice.invoiceType === 'individual'}
                                            onClick={() => (storeTaxInvoice.invoiceType = 'individual')}
                                            style={{
                                                color: storeTaxInvoice.invoiceType === 'individual' ? '#003B6F' : '#8A9BB0'
                                            }}
                                        />
                                        <FormControlLabel
                                            value="corporate"
                                            control={<RadioButton />}
                                            label={
                                                <Typography
                                                    component="h4"
                                                    style={{
                                                        color: storeTaxInvoice.invoiceType === 'corporate' ? '#003B6F' : '#8A9BB0',
                                                        fontSize: "16px",
                                                        fontWeight: 700
                                                    }}>
                                                    {translate('corporate')}
                                                </Typography>
                                            }
                                            checked={storeTaxInvoice.invoiceType === 'corporate'}
                                            onClick={() => (storeTaxInvoice.invoiceType = 'corporate')}
                                            style={{
                                                color: storeTaxInvoice.invoiceType === 'corporate' ? '#003B6F' : '#8A9BB0'
                                            }}
                                        />
                                    </RadioGroupStackStyled>
                                </RadioGroup>
                            </FormControl>
                        </Stack>
                        <Stack
                            direction={{
                                xs: 'column',
                                sm: 'row'
                            }}
                            justifyContent={{
                                xs: 'flex-start'
                            }}
                            gap={{
                                xs: '10px',
                                sm: '10px',
                                md: '40px'
                            }}
                            padding={{
                                xs: '20px',
                                sm: '20px',
                                md: '25px 30px'
                            }}
                            bgcolor="#E9F1FA"
                            mt={{
                                xs: '25px'
                            }}
                            alignItems={{
                                xs: 'flex-start',
                                sm: 'center'
                            }}>
                            <Stack width={'max-content'} style={{ textWrap: 'nowrap' }}>
                                <Typography variant="noVariant" component="h3" sx={{ fontSize: "16px", fontWeight: 700 }}>
                                    {storeTaxInvoice.invoiceType === 'individual' ? translate('government_id') : translate('taxpayer_id')}:
                                </Typography>
                            </Stack>
                            <Stack width={'100%'}>
                                <CustomInputWithEndorment
                                    label={null}
                                    type={'tel'}
                                    value={
                                        storeTaxInvoice.invoiceType === 'individual'
                                            ? taxIdFormatter(storeTaxInvoice.invoiceGovernmentId)
                                            : taxIdFormatter(storeTaxInvoice.invoiceTaxId)
                                    }
                                    onChange={e => {
                                        if (storeTaxInvoice.invoiceType === 'individual' && e.target.value.replace(/-/g, '').length <= 13) {
                                            if (/[0-9]/.test(e.target.value) || e.target.value === '') {
                                                storeTaxInvoice.invoiceGovernmentId = e.target.value.replace(/-/g, '')
                                            }
                                        } else if (storeTaxInvoice.invoiceType === 'corporate' && e.target.value.replace(/-/g, '').length <= 15) {
                                            if (/[0-9]/.test(e.target.value) || e.target.value === '') {
                                                storeTaxInvoice.invoiceTaxId = e.target.value.replace(/-/g, '')
                                            }
                                        }
                                    }}
                                    sx={{ '.MuiInputBase-input': { background: '#FFFFFF' } }}
                                    inputProps={{ style: { fontSize: '16px', color: '#000000' } }}
                                />
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack
                        paddingTop={{
                            xs: '30px 0px',
                            sm: '20px 0px',
                            md: '30px 0px'
                        }}>
                        <Stack
                            paddingTop={'25px'}
                            paddingLeft={{
                                xs: '20px',
                                md: '30px'
                            }}
                            paddingBottom={'25px'}>
                            <Typography variant="noVariant" component="h3" sx={{ fontSize: "16px", fontWeight: 700 }}>{translate('tax_invoice_address')}:</Typography>
                        </Stack>
                        <FormStack
                            padding={{
                                xs: '0px 20px',
                                md: '0px 30px'
                            }}
                            className={`invoice-form ${storeTaxInvoice.invoiceType === 'corporate' ? 'tax-invoice-corporate-form' : ''}`}>
                            <ThemeSelector countryCapitalize={StoreCountry.CountryCapitalize()}>
                                <Paper className="tax-invoice-form">
                                    {storeTaxInvoice[
                                        storeTaxInvoice.invoiceType.toLowerCase() === 'individual' ? 'invoiceIndividualForms' : 'invoiceCorporateForms'
                                    ].map((item, index) => {
                                        if (!inputs.includes(item.key)) return null

                                        let customTranslate = null

                                        if (item.key === 'fullNameNative') {
                                            customTranslate = 'fullNameTh'
                                        }

                                        if (item.key === 'fullName') {
                                            customTranslate = 'fullNameEn'
                                        }

                                        if (item.type === 'BranchSelect') {
                                            return (
                                                <Box item key={item.key}>
                                                    <CustomInputWithEndorment
                                                        label={translate(item.key)}
                                                        type="customx"
                                                        disabled
                                                        value={translate('head_office')}
                                                        onChange={e => {
                                                            if (item.args?.regx) {
                                                                const regex = new RegExp(item.args.regx)
                                                                if (regex.test(e.target.value)) {
                                                                    storeTaxInvoice.SetInvoiceValue(item.key, e.target.value)
                                                                }
                                                            } else {
                                                                storeTaxInvoice.SetInvoiceValue(item.key, e.target.value)
                                                            }
                                                        }}
                                                        endAdornment={<LockIcon />}
                                                    />
                                                </Box>
                                            )
                                        } else {
                                            if (item.key === 'zip_code') {
                                                return (
                                                    <Box item key={item.key}>
                                                        <ModalSearch
                                                            label={translate(item.key)}
                                                            options={[]}
                                                            value={storeTaxInvoice.GetInvoiceValue(item.key)}
                                                            onChange={e => {
                                                                let allowNumber = e.target.value.replace(/[^0-9]/g, '')
                                                                storeTaxInvoice.SetInvoiceValue(item.key, allowNumber)
                                                            }}
                                                            onSet={value => {
                                                                if (StoreTranslate.CurrentLanguage() === 'EN') {
                                                                    storeTaxInvoice.SetInvoiceValue('zip_code', value.zip)
                                                                    storeTaxInvoice.SetInvoiceValue('province', value.city_roman)
                                                                    storeTaxInvoice.SetInvoiceValue('district', value.sub1_roman)
                                                                    storeTaxInvoice.SetInvoiceValue('sub_district', value.sub2_roman)
                                                                } else {
                                                                    storeTaxInvoice.SetInvoiceValue('zip_code', value.zip)
                                                                    storeTaxInvoice.SetInvoiceValue('province', value.city_native)
                                                                    storeTaxInvoice.SetInvoiceValue('district', value.sub1_native)
                                                                    storeTaxInvoice.SetInvoiceValue('sub_district', value.sub2_native)
                                                                }
                                                            }}
                                                        />
                                                    </Box>
                                                )
                                            } else if (item.key === 'province') {
                                                return (
                                                    <Box
                                                        item
                                                        key={`${item.key}-${storeTaxInvoice.invoiceType}`}
                                                        sx={{ '.MuiStack-root.th_province_label_stack': { height: 'auto' } }}
                                                    >
                                                        <ThailandProvinceSelect
                                                            provinceKey="tax_invoice_province"
                                                            label={translate(item.key)}
                                                            value={storeTaxInvoice.GetInvoiceValue('province')}
                                                        />
                                                    </Box>
                                                )
                                            } else {
                                                return (
                                                    <Box item key={item.key}>
                                                        <DefaultInput
                                                            label={translate(customTranslate || item.key)}
                                                            type="text"
                                                            value={storeTaxInvoice.GetInvoiceValue(item.key)}
                                                            onChange={e => {
                                                                if (item.args?.regx) {
                                                                    const regex = new RegExp(item.args.regx)
                                                                    if (regex.test(e.target.value)) {
                                                                        storeTaxInvoice.SetInvoiceValue(item.key, e.target.value)
                                                                    }
                                                                } else {
                                                                    storeTaxInvoice.SetInvoiceValue(item.key, e.target.value)
                                                                }
                                                            }}
                                                        />
                                                    </Box>
                                                )
                                            }
                                        }
                                    })}
                                </Paper>
                            </ThemeSelector>
                            <Stack borderRadius={'8px'} bgcolor={'#FFF1DC'} padding="14px 20px" mb="20px" textAlign={'center'}>
                                <Typography variant="noVariant" component="p" sx={{ fontSize: "14px", fontWeight: 400, color: "#003B6F" }}>
                                    {translate('tax_invoice_warning')}
                                </Typography>
                            </Stack>
                        </FormStack>

                        {storeTaxInvoice.invoiceFormsErrors.length > 0 && (
                            <FormStack
                                mb="40px"
                                padding={{
                                    xs: '0px 20px',
                                    md: '0px 30px'
                                }}>
                                <Errors list={storeTaxInvoice.invoiceFormsErrors} />
                            </FormStack>
                        )}
                        <FormStack
                            mb="30px"
                            padding={{
                                xs: '0px 20px',
                                md: '0px 30px'
                            }}
                            className="invoice-form-actions">
                            <Grid container>
                                <Grid
                                    item
                                    sx={{ textAlign: { xs: 'center', sm: 'left' }, marginTop: { xs: '15px', sm: '0' } }}
                                    alignItems={'center'}
                                    display={'flex'}
                                    justifyContent={{ xs: 'center', sm: 'flex-start' }}
                                    disabled={isLoading}>
                                    <Typography
                                        variant="noVariant"
                                        component="h3"
                                        sx={{ textDecoration: 'underline', fontWeight: 400, cursor: 'pointer', fontSize: "14px" }}
                                        onClick={() => {
                                            storeTaxInvoice.invoiceFormsErrors = []
                                            navigate(-1)
                                        }}>
                                        {translate('cancel')}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <DefaultButton
                                        onClick={() => SaveTaxInvoice()}
                                        disabled={isLoading}
                                        isloading={isLoading.toString()}
                                        titleText={
                                            <Typography variant="noVariant" component="h3" sx={{ color: '#fff', fontSize: "20px", fontWeight: 600 }}>
                                                {translate('save')}
                                            </Typography>
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </FormStack>
                    </Stack>
                </Stack>
            </TaxInvoiceWrapper>
        </ThemeProvider>
    )
})

const TaxInvoiceWrapper = styled(Stack)`
    display: flex;
    align-items: center;
    background-color: #d1d9e2;
    padding: 20px 15px;
    min-height: calc(100vh - 197px);

    * {
        font-family: Inter, NotoSansThai  !important;
    }
    @media screen and (min-width: 700px) {
        padding-top: 30px;
        padding-bottom: 30px;
    }

    .sub-wrapper {
        background-color: #ffffff;
        width: 100%;
        fill: #fff;
        stroke-width: 1px;
        stroke: #f1f5f8;
        box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.05);
        border-radius: 12px;
        @media screen and (min-width: 700px) {
            width: 80%;
        }
        @media screen and (min-width: 1024px) {
            width: 700px;
        }
    }
`

const CustomInputWithEndorment = styled(DefaultInput)`
    * {
        font-family: Inter, NotoSansThai !important;
    }

    .MuiInputAdornment-root {
        position: absolute;
        right: 8px;
        width: 20px;
        height: 20px;
    }

    .MuiIconButton-root {
        margin-right: 0px;
        padding-right: 0px;
        padding-left: 0px;
        width: 10px;
        height: 13px;
    }
    .MuiInputBase-input {
       background: #FFFFFF;
    }
`

const FormStack = styled(Stack)`
    
    &.invoice-form-actions {
        .MuiGrid-root {
            justify-content: center;
            align-items: center;
            flex-direction: column-reverse;
            @media screen and (min-width: 600px) {
                flex-direction: row;
                justify-content: space-between;
            }
            &.MuiGrid-item {
                width: 100%;
                @media screen and (min-width: 600px) {
                    width: calc(50% - 10px);
                }
            }
        }
    }
`

const RadioGroupStackStyled = styled(Stack)`
    justify-content: space-between;
    flex-direction: row;

    .MuiRadio-root {
        padding: 0px;
        padding-right: 10px;
    }

    .MuiFormControlLabel-root {
        margin-left: 0px;
    }

    @media screen and (min-width: 600px) {
        justify-content: flex-start;
        grid-column-gap: 120px;
        column-gap: 120px;
        gap: 120px;
    }
`


export default TaxInvoice
